import { ISelectOption, ISelectOptions } from 'react-ocean-forms-bootstrap';
import { ViewMode } from '../components/Common/ViewMode';
import { IStatusUtil } from './IStatusUtil';
import { Status } from './model';
import { Role } from '../Roles';
import { KomponenteStatus, ParameterStatus } from '../generated/types';


class ParameterStatusUtilImpl extends IStatusUtil {

  public PS1: Status = {id: 'PS1', name: 'Vorgeschlagen'};
  public PS2A: Status = {id: 'PS2A', name: 'Freigegeben/Aktiv'};
  public PS2B: Status = {id: 'PS2B', name: 'Freigegeben/Inaktiv'};
  public PS3: Status = {id: 'PS3', name: 'Abgelehnt'};
  
  public list: Status[] = [this.PS1, this.PS2A, this.PS2B, this.PS3];

  getStatus = (id: string): Status => {
    const result =  this.list.find(e => e.id === id);
    if (result) {
      return result;
    }
    throw new Error('Status nicht definiert');
  }

  getStatusEnumFromStatus(id: string): ParameterStatus {
    let statusEnum: ParameterStatus | undefined;
    Object.keys(ParameterStatus).forEach( key => {
      if(ParameterStatus[key] === id) {
        statusEnum = ParameterStatus[key];
      }
    });
    if(statusEnum) {
      return statusEnum;
    }
    throw new Error('ParameterStatus nicht definiert.')
  }

  getStatusList = (role: string, view: ViewMode, selected?: ISelectOption): ISelectOptions => {
    const statusList: ISelectOptions = [];
    
    if (role === Role.EHPC_READ && ViewMode.Search === view) {
      statusList.push(this.getStatusOption(this.PS2A));
      statusList.push(this.getStatusOption(this.PS2B));
    }
    if (role === Role.EHPC_REQU && ViewMode.Search === view) {
      statusList.push(this.getStatusOption(this.PS1));
      statusList.push(this.getStatusOption(this.PS2A));
      statusList.push(this.getStatusOption(this.PS2B));
    }
    if (role === Role.EHPC_RW && ViewMode.Search === view) {
      statusList.push(this.getStatusOption(this.PS1));
      statusList.push(this.getStatusOption(this.PS2A));
      statusList.push(this.getStatusOption(this.PS2B));
      statusList.push(this.getStatusOption(this.PS3));
    }
    if (role === Role.EHPC_RW && ViewMode.New === view) {
      statusList.push(this.getStatusOption(this.PS1));
      // EINPAR-473 / EINPAR-471 / EINPAR-414
      statusList.push(this.getStatusOption(this.PS2A));
    }
    if (role === Role.EHPC_REQU && ViewMode.New === view) {
      statusList.push(this.getStatusOption(this.PS1));

    } 
    if (role === Role.EHPC_RW && ViewMode.Edit === view) {
      if(selected && selected.value === this.PS1.id) {
        statusList.push(this.getStatusOption(this.PS1));
        // EINPAR-435 disabled for release 1.0.x
        // statusList.push(this.getStatusOption(this.PS2A));
      }
      if(selected && (selected.value === this.PS2A.id || selected.value === this.PS2B.id)) {
        statusList.push(this.getStatusOption(this.PS2A));
        statusList.push(this.getStatusOption(this.PS2B));
      }
    }
    
    return statusList;
  }


  removeInactiveStatus = (opt: ISelectOption | undefined): ISelectOption | undefined => {
    if(opt && opt.value) {
      // do not crash on JSON parsing
      try {
        const value = JSON.parse(opt.value);
        if(value.status !== KomponenteStatus.Ks2B) {
          return opt;
        }
      } catch(e) {
        return undefined;
      }
    }
    return undefined;
  }

  removeInactiveStatusList = (opt: ISelectOption[] | undefined): ISelectOption[] | undefined => {
    console.log('inactive opt', opt);
    // @ts-ignore
    const option = opt && opt !== "" ? opt : undefined;
    // @ts-ignore
    const result = this.removeInactiveStatus(option);
    console.log('inactive status', result);
    if(result) return [result];
    return undefined;
  }
}

export const ParameterStatusUtil = new ParameterStatusUtilImpl();
